import { render, staticRenderFns } from "./DividerBar.vue?vue&type=template&id=7189ccba&scoped=true"
import script from "./DividerBar.vue?vue&type=script&lang=js"
export * from "./DividerBar.vue?vue&type=script&lang=js"
import style0 from "./DividerBar.vue?vue&type=style&index=0&id=7189ccba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7189ccba",
  null
  
)

export default component.exports